module.exports = {
  baseUrl: `http://192.168.0.135:3000/`
}
